import * as actions from "./actions";
import _ from "underscore";
import {
  CREDIT_SETTLEMENT_FOR_USER_GET_DETAILS_SUCCESS,
  CREDIT_SETTLEMENT_LIST_GET_DETAILS_SUCCESS,
} from "../../creditSettlement/actions";

export let initialState = {
  fetching: false,
  fetched: false,
  error: null,
  data: [],
  idSortedData: {},
};

function getObjectWithIdsAsKeys(array) {
  let obj = {};

  for (let i = 0; i < array.length; i++) {
    obj[array[i].Id] = array[i];
  }

  return obj;
}

export let restRepayments = (state = initialState, action) => {
  switch (action.type) {
    case actions.REST_REPAYMENT_FETCH_REQUEST:
      return Object.assign({}, state, {
        fetching: true,
      });

    case actions.REST_REPAYMENT_FETCH_SUCCESS: {
      return Object.assign({}, state, {
        fetching: false,
        fetched: true,
        data: action.response,
        idSortedData: getObjectWithIdsAsKeys(action.response),
      });
    }

    case actions.REST_REPAYMENT_FETCH_ERROR:
      return Object.assign({}, state, {
        fetching: false,
        error: action.error,
      });

    case actions.MAKE_REST_REPAYMENT_SUCCESS: {
      const loanId = action.dataSent.LoanId;

      let index = _.findIndex(state.data, (l) => {
        return l.Id === loanId;
      });

      let withRemovedId = Object.assign(state.idSortedData);
      delete withRemovedId[loanId];

      return Object.assign({}, state, {
        data: [...state.data.slice(0, index), ...state.data.slice(index + 1)],
        idSortedData: withRemovedId,
      });
    }

    case CREDIT_SETTLEMENT_FOR_USER_GET_DETAILS_SUCCESS:
    case CREDIT_SETTLEMENT_LIST_GET_DETAILS_SUCCESS: {
      var forId = action.additionalData;

      var itemToUpdateIndex = _.findIndex(state.data, (item) => {
        return item.Id === forId;
      });

      if (itemToUpdateIndex === -1) return state;

      // There is a mismatch between backend objects it needs to be done like that unfortunately ;/
      // TODO change it later
      action.response.Id = action.response.IntId;
      action.response = {
        ...state.data[itemToUpdateIndex],
        ...action.response,
      };

      return Object.assign({}, state, {
        data: [
          ...state.data.slice(0, itemToUpdateIndex),
          action.response,
          ...state.data.slice(itemToUpdateIndex + 1),
        ],
      });
    }

    default:
      return state;
  }
};

export default restRepayments;
